import React, { createContext, useContext, useMemo } from "react";
import ec from "../i18n/ec.json";
import en from "../i18n/en.json";

const DICTS = { ec, en };

export const I18nContext = createContext({ lang: "ec", t: (k) => k, dict: ec });

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => {
    if (acc == null) return undefined;
    return acc[key];
  }, obj);
}

export const I18nProvider = ({ lang = "ec", children }) => {
  const value = useMemo(() => {
    const dict = DICTS[lang] || DICTS.ec;
    const t = (key, fallback) => {
      const v = getByPath(dict, key);
      if (v === undefined || v === null) return fallback ?? key;
      return v;
    };
    return { lang, t, dict };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
